module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('Notifications', {
    attrs: {
      "userHasAccess": _vm.userHasAccess,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('Alerts', {
    attrs: {
      "devicesLoaded": _vm.devicesLoaded,
      "devices": _vm.devices,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('Items', {
    attrs: {
      "claimsSubheader": _vm.claimsSubheader,
      "itemsSubheader": _vm.itemsSubheader,
      "claims": _vm.claims,
      "user": _vm.user,
      "devices": _vm.devices
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2613b6c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/index.vue
// module id = 1285
// module chunks = 0